import {
    OptionPicker,
    createOptionPicker,
    OPTION_PICKER_ITEM_CLASSNAME,
} from '@vfde-brix/ws10/option-picker';
import { JarvisHomebox } from '../interface';
import { createComponentById } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';

/**
 * Create Brix Option Picker component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @param {Function} onChange - Select event handler.
 * @returns {OptionPicker|null} Option Picker component or null if element with given id is not found.
 */
export const mountOptionPicker = (id: HtmlId, onChange: Function): OptionPicker | null =>
    createComponentById(createOptionPicker, id, {
        onChange: ({ target }) => {
            if (target && target instanceof HTMLInputElement) {
                onChange(target.value);
            }
        },
    });

const updateDisplayMetacodes = (pickerEl: Element) => {
    for (const item of pickerEl.getElementsByClassName(OPTION_PICKER_ITEM_CLASSNAME)) {
        const [ input ] = item.getElementsByTagName('input');
        const [ label ] = item.getElementsByTagName('label');

        label.setAttribute('data-metacode', input.value);
    }
};

/**
 * Update OptionPicker component used for product selection.
 * @param {OptionPicker|null} picker - Component to update.
 * @param {JarvisHomebox[]} routers - Router products to show on the page.
 * @param {string=} selectedId - Currently selected router product metacode.
 * @param {string[]=} availableIds - Available router product metacodes returned after login.
 * @param {boolean} disableOption - disableOption is set to True if diableBooking state is True
 */
export const updateOptionPicker = (
    picker: OptionPicker | null,
    routers: JarvisHomebox[],
    selectedId: string,
    availableIds: string[],
    disableOption: boolean,
) => {
    if (!picker || !routers.length) {
        return;
    }

    const props = picker.getProperties();

    props.items = routers.map(router => ({
        stdValue: router.id,
        stdPrimaryLabel: router.name,
        optDisabled: disableOption || !availableIds.includes(router.id),
        optChecked: router.id === selectedId,
    }));

    picker.update(props);

    updateDisplayMetacodes(picker.getContainerElement());
};
